const { GET_MANAGE_DEVICES } = require("src/actions/types");

const initialState = { ManageDevicesList: [] };

const ManagesDevicesReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_MANAGE_DEVICES:
      return {
        ...state,
        ManageDevicesList: payload,
      };
    default:
      return state;
  }
};

export { ManagesDevicesReducer };
